import { TransitionsOptions } from '@mui/material';

const transitions: TransitionsOptions = {
  easing: {
    easeInOut: 'cubic-bezier(0.87, 0, 0.13, 1)',
    easeOut: 'cubic-bezier(0.16, 1, 0.3, 1)',
    easeIn: 'cubic-bezier(0.7, 0, 0.84, 0)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
  },
  duration: {
    shortest: 150,
    shorter: 200,
    short: 250,
    standard: 500,
    complex: 750,
    enteringScreen: 500,
    leavingScreen: 500
  }
};

export default transitions;
